var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "on-clickaway",
          rawName: "v-on-clickaway",
          value: _vm.away,
          expression: "away",
        },
      ],
      staticClass: "fab-wrapper",
      style: [_vm.pos, { zIndex: _vm.zIndex }, { position: _vm.positionType }],
      attrs: { id: _vm.position + "-wrapper" },
    },
    [
      _c(
        "div",
        {
          staticClass: "actions-container",
          style: _vm.listPos,
          attrs: { id: _vm.position + "-action" },
        },
        [
          _c(
            "transition",
            {
              attrs: {
                name: "fab-actions-appear",
                "enter-active-class": _vm.transitionEnter,
                "leave-active-class": _vm.transitionLeave,
              },
            },
            [
              _c(
                "ul",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.toggle,
                      expression: "toggle",
                    },
                  ],
                  staticClass: "fab-list",
                },
                [
                  _vm._l(_vm.actions, function (action) {
                    return [
                      _c(
                        "transition",
                        {
                          key: action.name,
                          attrs: {
                            "enter-active-class":
                              "animated quick animate__zoomInUp",
                            "leave-active-class":
                              "animated quick animate__zoomOutDown",
                          },
                          on: {
                            "after-enter": _vm.afterActionsTransitionEnter,
                          },
                        },
                        [
                          action.tooltip
                            ? [
                                _vm.toggle && _vm.isActionVisible(action)
                                  ? _c(
                                      "li",
                                      {
                                        directives: [
                                          {
                                            name: "tooltip",
                                            rawName: "v-tooltip",
                                            value: {
                                              content: action.tooltip,
                                              placement: _vm.tooltipPosition,
                                              classes: "fab-tooltip",
                                              trigger: _vm.tooltipTrigger,
                                            },
                                            expression:
                                              "{ content: action.tooltip, placement: tooltipPosition, classes: 'fab-tooltip', trigger: tooltipTrigger}",
                                          },
                                        ],
                                        ref: "actions",
                                        refInFor: true,
                                        staticClass: "pointer",
                                        style: {
                                          "background-color":
                                            action.color || _vm.bgColor,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toParent(action.name)
                                          },
                                        },
                                      },
                                      [
                                        _c("span", { staticClass: "icon" }, [
                                          _c("i", {
                                            class: [
                                              _vm.actionIconSize,
                                              "material-icons",
                                              `mdi mdi-${action.icon}`,
                                            ],
                                          }),
                                        ]),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            : [
                                _vm.toggle
                                  ? _c(
                                      "li",
                                      {
                                        staticClass: "pointer",
                                        style: {
                                          "background-color":
                                            action.color || _vm.bgColor,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toParent(action.name)
                                          },
                                        },
                                      },
                                      [
                                        _c("span", { staticClass: "icon" }, [
                                          _c("i", {
                                            class: [
                                              _vm.actionIconSize,
                                              "material-icons",
                                              `mdi mdi-${action.icon}`,
                                            ],
                                          }),
                                        ]),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                        ],
                        2
                      ),
                    ]
                  }),
                ],
                2
              ),
            ]
          ),
        ],
        1
      ),
      _vm.rippleShow
        ? [
            _vm.mainTooltip
              ? [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "ripple",
                          rawName: "v-ripple",
                          value:
                            _vm.rippleColor == "light"
                              ? "rgba(255, 255, 255, 0.35)"
                              : "",
                          expression:
                            "rippleColor == 'light' ? 'rgba(255, 255, 255, 0.35)' : ''",
                        },
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: {
                            content: _vm.mainTooltip,
                            placement: _vm.tooltipPosition,
                            classes: "fab-tooltip",
                          },
                          expression:
                            "{ content: mainTooltip, placement: tooltipPosition, classes: 'fab-tooltip' }",
                        },
                      ],
                      staticClass:
                        "fab-main pointer has-background-primary-35 transparent-icon",
                      style: { padding: _vm.paddingAmount },
                      on: {
                        click: function ($event) {
                          _vm.toggle = !_vm.toggle
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "icon material-icons main",
                          class: { rotate: _vm.toggle },
                        },
                        [
                          _c("i", {
                            staticClass: "mdi mdi-plus",
                            class: [_vm.mainIconSize],
                          }),
                        ]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "icon material-icons close",
                          class: { rotate: _vm.toggle },
                        },
                        [
                          _c("i", {
                            staticClass: "mdi mdi-plus",
                            class: [_vm.mainIconSize],
                          }),
                        ]
                      ),
                    ]
                  ),
                ]
              : [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "ripple",
                          rawName: "v-ripple",
                          value:
                            _vm.rippleColor == "light"
                              ? "rgba(255, 255, 255, 0.35)"
                              : "",
                          expression:
                            "rippleColor == 'light' ? 'rgba(255, 255, 255, 0.35)' : ''",
                        },
                      ],
                      staticClass: "fab-main pointer",
                      style: {
                        "background-color": _vm.bgColor,
                        padding: _vm.paddingAmount,
                      },
                      on: {
                        click: function ($event) {
                          _vm.toggle = !_vm.toggle
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "icon material-icons main",
                          class: { rotate: _vm.toggle },
                        },
                        [
                          _c("i", {
                            staticClass: "mdi mdi-plus",
                            class: [_vm.mainIconSize],
                          }),
                        ]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "icon material-icons close",
                          class: { rotate: _vm.toggle },
                        },
                        [
                          _c("i", {
                            staticClass: "mdi mdi-plus",
                            class: [_vm.mainIconSize],
                          }),
                        ]
                      ),
                    ]
                  ),
                ],
          ]
        : [
            _vm.mainTooltip
              ? [
                  _c(
                    "div",
                    {
                      staticClass: "fab-main pointer",
                      style: {
                        "background-color": _vm.bgColor,
                        padding: _vm.paddingAmount,
                      },
                      attrs: {
                        "v-tooltip": {
                          content: _vm.mainTooltip,
                          placement: _vm.tooltipPosition,
                          classes: "fab-tooltip",
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "icon material-icons main",
                          class: { rotate: _vm.toggle },
                        },
                        [
                          _c("i", {
                            staticClass: "mdi mdi-plus",
                            class: [_vm.mainIconSize],
                          }),
                        ]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "icon material-icons close",
                          class: { rotate: _vm.toggle },
                        },
                        [
                          _c("i", {
                            staticClass: "mdi mdi-plus",
                            class: [_vm.mainIconSize],
                          }),
                        ]
                      ),
                    ]
                  ),
                ]
              : [
                  _c(
                    "div",
                    {
                      staticClass: "fab-main pointer",
                      style: {
                        "background-color": _vm.bgColor,
                        padding: _vm.paddingAmount,
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "icon material-icons main",
                          class: { rotate: _vm.toggle },
                        },
                        [
                          _c("i", {
                            staticClass: "mdi mdi-plus",
                            class: [_vm.mainIconSize],
                          }),
                        ]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "icon material-icons close",
                          class: { rotate: _vm.toggle },
                        },
                        [
                          _c("i", {
                            staticClass: "mdi mdi-plus",
                            class: [_vm.mainIconSize],
                          }),
                        ]
                      ),
                    ]
                  ),
                ],
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }